module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"blueprints":"Blueprints","preset":"Preset","presets":["No required","No required & auto-post","All required","1 required (random)","2 required (random)","3 required (random)"]}}')
  delete Component.options._Ctor
}
